import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";

const purchaseRouters: RouteRecordRaw[] = [
    {
        path: "/purchase",
        name: "Purchase",
        meta: {
            title: "采购管理"
        },
        component: Layout,
        children: [
            // 订单
            {
                path: "order",
                name: "OrderList",
                meta: {
                    title: "订单管理",
                    activeMenu: "OrderList",
                    pageType: PAGE_TYPE.LIST.code
                },
                component: () => import("@/views/pages/purchaseManagement/order/index.vue")
            },
            {
                path: "order/add",
                name: "OrderAdd",
                meta: {
                    title: "新增订单",
                    hidden: true,
                    activeMenu: "OrderList",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/order/form.vue")
            },
            {
                path: "order/edit/:id",
                name: "OrderEdit",
                meta: {
                    title: "编辑订单",
                    hidden: true,
                    activeMenu: "OrderList",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/order/form.vue")
            },
            {
                path: "order/detail/:id",
                name: "OrderDetail",
                meta: { title: "订单详情", hidden: true, activeMenu: "OrderList", keepAlive: true },
                component: () => import("@/views/pages/purchaseManagement/order/details.vue")
            },
            {
                path: "delivery",
                name: "Delivery",
                meta: { title: "提货管理", keepAlive: true },
                component: () => import("@/views/pages/purchaseManagement/deliveryManagement/index.vue")
            },
            {
                path: "delivery/deliveryDetail",
                name: "DeliveryDetail",
                meta: { title: "提货详情", hidden: true, activeMenu: "Delivery" },
                component: () => import("@/views/pages/purchaseManagement/deliveryManagement/detail.vue")
            },
            {
                path: "receipt",
                name: "Receipt",
                meta: {
                    title: "签收管理",
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/receiptManagement/index.vue")
            },
            {
                path: "receipt/add",
                name: "ReceiptAdd",
                meta: {
                    title: "新增签收",
                    hidden: true,
                    activeMenu: "Receipt",
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/receiptManagement/form/index.vue")
            },
            {
                path: "receipt/edit/:id",
                name: "ReceiptEdit",
                meta: { title: "编辑签收", hidden: true, activeMenu: "Receipt", keepAlive: true },
                component: () => import("@/views/pages/purchaseManagement/receiptManagement/form/index.vue")
            },
            {
                path: "receipt/detail/:id",
                name: "ReceiptInfo",
                meta: { title: "签收详情", hidden: true, activeMenu: "Receipt" },
                component: () => import("@/views/pages/purchaseManagement/receiptManagement/detail.vue")
            },
            // 结算
            {
                path: "reconciliation",
                name: "ConsoleReconciliation",
                meta: {
                    title: "结算管理",
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/reconciliation/index.vue")
            },
            {
                path: "reconciliation/add",
                name: "PurchaseReconciliationAdd",
                meta: {
                    title: "新增结算",
                    hidden: true,
                    activeMenu: "ConsoleReconciliation",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/reconciliation/form.vue")
            },
            {
                path: "reconciliation/edit/:id",
                name: "PurchaseReconciliationEdit",
                meta: {
                    title: "修改结算",
                    hidden: true,
                    activeMenu: "ConsoleReconciliation",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/purchaseManagement/reconciliation/form.vue")
            },
            {
                path: "reconciliation/detail/:id",
                name: "PurchaseReconciliationInfo",
                meta: { title: "结算详情", hidden: true, activeMenu: "ConsoleReconciliation" },
                component: () => import("@/views/pages/purchaseManagement/reconciliation/detail.vue")
            }
        ]
    }
];

export default purchaseRouters;
